// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_RevenueConciliationCompleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/revenue_conciliation_complete/{period_id}
 *
 * Completes revenue conciliation for a payroll period. No body required — period_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Payroll_RevenueConciliationCompleteInput {}

registerContract('Payroll_RevenueConciliationCompleteInput', {})
